import styled from 'styled-components';

export const MainDiv = styled.div`
    padding: 30px;
    margin: 0;
`;

export const LabelWrap = styled.div`
    display: flex;
    align-items: center;
`;

export const ImportLabel = styled.label`
    font-size: 16px;
    line-height: 21px;
    color: #fff;
    font-weight: 500;
    padding: 8px 17px;
    background-color: #1B49EA;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: fit-content;
    cursor: pointer;
    margin-right: 20px;
`;

export const ImportInput = styled.input`
    display: none;
`;

export const ButtonWrap = styled.div`
    display: flex;
    align-items: center;
`;

export const Button = styled.button`
    padding: 10px;
    border-radius: 8px;
    border: 2px solid #eeeeee;
    margin: 0 5px;

    &:hover {
        background-color: #dbd2d2;
        border-color: #dbd2d2;
    }

    &:focus {
        background-color: #dbd2d2;
        border-color: #dbd2d2;
    }
`;

export const Table = styled.table`
    border-collapse: collapse;
    margin-top: 30px;
    table-layout: fixed;

    & div {
        padding: 20px;
        height: 100px;
        width: 300px;
        overflow: scroll;
        border: 2px solid #eeeeee;
    }

    & th {
        & div {
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
`;

export const ErrorDiv = styled.div`
    border: 2px solid red;
    color: red;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const RemoveButton = styled.button`
    font-size: 16px;
    line-height: 21px;
    color: #fff;
    font-weight: 500;
    padding: 8px 17px;
    background-color: #1B49EA;
    border-radius: 8px;
    max-width: 192px;
    text-align: center;
    display: block;
    width: 100%;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
`;

export const SubmitButton = styled.button`
    font-size: 16px;
    line-height: 21px;
    color: #fff;
    font-weight: 500;
    padding: 8px 17px;
    background-color: #1B49EA;
    border-radius: 8px;
    max-width: 192px;
    text-align: center;
    display: block;
    width: 100%;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
`;

export const FileError = styled.div`
    margin-top: 20px;
    color: red;
`;

export const SubmitSheetError = styled.div`
    font-size: 16px;
    line-height: 21px;
    color: #fff;
    font-weight: 500;
    padding: 8px 17px;
    background-color: red;
    border: 2px solid red;
    text-align: center;
    border-radius: 8px;
    margin-left: 20px;
`;